import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { followUser, unfollowUser } from '../actions/follow';
import Button from './Button/Button';
import Icon from './Icon/Icon';
import { createUrl, getQueryObject, getQueryString } from '../utils/url';
import BasicLink from './BasicLink';

const mapStateToProps = ({
  following,
  session: { user },
  location: { baseURL },
}) => ({
  following,
  currentUser: user,
  baseURL,
});
const mapDispatchToProps = { follow: followUser, unfollow: unfollowUser };

const BUTTON_PROPS = { buttonStyle: 'basic', withIcon: true };

const Follow = ({ onClick, track }) => (
  <Button {...BUTTON_PROPS} onClick={onClick} track={{ ...track, action: 'Follow' }} data-name="follow">
    <span>Follow</span>
    <Icon name="followuser" />
  </Button>
);

const Unfollow = ({ hover, onClick, track }) => (
  <Button {...BUTTON_PROPS} onClick={onClick} track={{ ...track, action: 'Unfollow' }} data-name="unfollow">
    <span>{ hover ? 'Unfollow' : 'Following' }</span>
    <Icon name={hover ? 'unfollowuser' : 'check'} />
  </Button>
);

const Pending = () => (
  <Button {...BUTTON_PROPS} disabled data-name="pending">
    <span>Pending</span>
    <Icon name="clock" />
  </Button>
);

const FollowButton = ({
  relationshipId, pending, hover, unfollow, follow
}) => {
  if (pending) return <Pending />;

  if (relationshipId) return <Unfollow hover={hover} onClick={unfollow} />;

  return <Follow onClick={follow} />;
};

const SignIn = ({
  baseURL, userId, location, track
}) => {
  const newQuery = {
    ...getQueryObject(location.search),
    follow: userId
  };
  const routeTo = {
    ...location,
    search: `?${getQueryString(newQuery)}`
  };
  const loginPath = `/sign/in/?routeTo=${encodeURIComponent(createUrl(baseURL, routeTo))}`;

  return (
    <BasicLink to={loginPath} external withIcon track={{ ...track, action: 'SignInToFollow' }} data-name="sign-in">
      <span>Follow</span>
      <Icon name="followuser" />
    </BasicLink>
  );
};

class FollowButtonContainer extends Component {
  state = {
    hover: false
  }

  onMouseEnter = () => {
    this.setState({ hover: true });
  }

  onMouseLeave = () => {
    this.setState({ hover: false });
  }

  render() {
    const {
      following, userId, unfollow, follow, track, currentUser, baseURL, location
    } = this.props;
    const { hover } = this.state;

    if (!userId) return null;

    if (!currentUser) {
      return <SignIn userId={userId} track={track} baseURL={baseURL} location={location} />;
    }

    const { pendingUsers, users } = following;
    const relationshipId = users && users[userId];
    const pending = pendingUsers && pendingUsers[userId];
    return (
      <div onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
        <FollowButton
          pending={pending}
          relationshipId={relationshipId}
          hover={hover}
          unfollow={() => unfollow({ relationshipId, userId })}
          follow={() => follow(userId)}
          track={track}
        />
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(FollowButtonContainer));



// WEBPACK FOOTER //
// ./src/universal/ui/components/FollowButton.js